import { useState } from "react";
import axios from "axios";

const useAuthorisedValues = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const mainApi = '/koha/authorised_values'
    const [data, setData] = useState([])

    const getAuthorisedValuesData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get(`${mainApi}`, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })

                return {
                    ...data
                }
            });
    }
    const postAuthorisedValuesData = (data) => {
        onBefore({ axiosMode: "post", values: data })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({ axiosMode: "post", status: status === "success" ? "success" : "error", responseData })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "post", status: "error", ex })
            })
    }
    const patchAuthorisedValuesData = (data) => {
        onBefore({ axiosMode: "patch", values: data })
        axios.patch(mainApi,
                data
        )
            .then((response) => {
                const result = response.data
                const bSuccess = result?.status === "success";
                onFinish({ axiosMode: "patch", status: bSuccess ? "success" : "error", values: bSuccess ? result.data : result.message })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "patch", status: "error", ex })
            })
    }
    const deleteAuthorisedValuesData = (data) => {
        onBefore({ axiosMode: "delete", values: data })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                const result = response.data
                const bSuccess = result?.status === "success";
                onFinish({ axiosMode: "delete", status: bSuccess ? "success" : "error", values: bSuccess ? result.data : result.message })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "delete", status: "error", ex })
            })
    }
    return {
        AuthorisedValuesData: data,
        getAuthorisedValuesData,
        postAuthorisedValuesData,
        patchAuthorisedValuesData,
        deleteAuthorisedValuesData
    }
}
export { useAuthorisedValues }
